// Compact line-icon set (24x24, stroke = currentColor) used across the nav.
// Aviation-flavored where it fits: gauge for the dashboard, a plane for Jobs/Flights.
const PATHS = {
  gauge: 'M12 13l4-3M4.5 18a9 9 0 1115 0M12 13a1.5 1.5 0 100 3 1.5 1.5 0 000-3z',
  trending: 'M3 17l6-6 4 4 8-8M21 7h-5M21 7v5',
  bank: 'M3 9l9-5 9 5M5 9v9M19 9v9M9 9v9M15 9v9M3 21h18',
  cart: 'M4 5h2l1.6 9.5a1 1 0 001 .8h8.2a1 1 0 001-.8L20 8H7M9 21a1 1 0 100-2 1 1 0 000 2zm9 0a1 1 0 100-2 1 1 0 000 2z',
  file: 'M7 3h7l5 5v13a0 0 0 01-0 0H7a1 1 0 01-1-1V4a1 1 0 011-1zM14 3v5h5',
  filecheck: 'M7 3h7l5 5v13H7a1 1 0 01-1-1V4a1 1 0 011-1zM14 3v5h5M9.5 15l1.8 1.8L15 13',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zM5 20a7 7 0 0114 0',
  box: 'M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8',
  card: 'M3 6h18a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V7a1 1 0 011-1zM2 10h20',
  deposit: 'M12 3v9m0 0l-3.5-3.5M12 12l3.5-3.5M4 17v2a1 1 0 001 1h14a1 1 0 001-1v-2',
  check: 'M12 21a9 9 0 100-18 9 9 0 000 18zM8.5 12l2.5 2.5L16 9',
  receipt: 'M5 3h14v18l-2.5-1.5L14 21l-2-1.5L10 21l-2.5-1.5L5 21V3zM8.5 8h7M8.5 12h7',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  plane: 'M21 12.5L3 19l3.5-6.5L3 6l18 6.5zM6.5 12.5H21',
  wrench: 'M14.5 6a3.5 3.5 0 014.9 4.2L21 12l-2 2-7.5 7.5a2.1 2.1 0 01-3-3L16 11l-1.5-1.5A3.5 3.5 0 0114.5 6z',
};

export default function NavIcon({ name, size = 18, className = 'nav-icon' }) {
  const d = PATHS[name] || PATHS.file;
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}
